/**
 * Controller: TemplatesCreateSchedulesHolidaysExceptionsModal
 */
angular.module('acme.view.application.templates.create.schedules.holidaysExceptions.controllers', [
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.userPreferences'
])
.controller('TemplatesCreateSchedulesHolidaysExceptionsModalController', [ '$scope', '$uibModalInstance', '$filter', 'CalendarService', 'HelpersService', 'exceptions', 'UserPreferencesService', function ($scope, $uibModalInstance, $filter, CalendarService, HelpersService, exceptions, UserPreferencesService) {

    $scope.errors = [];

    $scope.model = [];

    $scope.selected = [];
    
    $scope.dateFormat = UserPreferencesService.getDateFormat('standardDate', 'dateFormat');
    
    $scope.hourFormat = UserPreferencesService.getDateFormat('standardTime', 'hourFormat');
    
    $scope.init = function() {
      this.model = $scope.process(exceptions);
      this.toggleView('current');
    };

    /**
     * @param {Array | undefined} list 
     */
    $scope.process = function(list) {
      var i, ii,
          j, jj,
          d, date, hours,
          r = [],
          past = [],
          current = [],
          today = new Date();

      list = Array.isArray(list) ? list : [];

      today = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);

      for (i=0,ii=list.length;i<ii;i++) {

        hours = [];

        d = list[i].date.split('-');
        date = new Date(parseInt(d[0], 10), parseInt(d[1], 10) - 1, parseInt(d[2], 10), 0, 0, 0);


        for (j=0,jj=list[i].hours.length;j<jj;j++) {
          if (list[i].hours[j].toLowerCase() === 'closed') {
            hours.push(HelpersService.cap(list[i].hours[j]) + ' all day');
          } else {
            hours.push('Open ' + CalendarService.rangeToTime(list[i].hours[j]));
          }
        }

        // Skip if holiday is in the past
        if (date.getTime() < today.getTime()) {
          past.push({
            date: $filter('date')(date, $scope.dateFormat),
            name: list[i].name,
            hours: hours
          });
        }else {
          current.push({
            date: $filter('date')(date, $scope.dateFormat),
            name: list[i].name,
            hours: hours
          });
        }
      }

      return {
        past: past,
        current: current
      };
    };

    $scope.toggleView = function(type) {

      if (type === 'all') {
        $scope.selected = $scope.model.past.concat($scope.model.current);
      }else if ($scope.model.hasOwnProperty(type)) {
        $scope.selected = $scope.model[type];
      }

    };
    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.hasExceptions = function() {
      return (this.selected instanceof Array && this.selected.length);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);